<tad-dialog-container [dialogTitle]="'Share'">
  <div class="dialog-content">
    <h1 class="form-title">Share Your Choices</h1>
    <div class="description">
      Share your institution goals with others by emailing your choices.
    </div>
    <div>
      <mat-form-field class="w-100" appearance="fill">
        <input [formControl]="email" type="text" placeholder="Enter Email" matInput />
        <div
          (click)="send()"
          matSuffix
          class="d-flex justify-content-center align-items-center gap-xs">
          <mat-icon svgIcon="send-icon"></mat-icon>
          <span class="text-white font-size-14">Send</span>
        </div>
      </mat-form-field>
    </div>
  </div>
  <div class="dialog-actions d-flex justify-content-between align-items-center gap-md">
    <div class="text-left">
      Download and save this page directly to your computer to easily access and share at anytime.
    </div>
    <button mat-flat-button color="primary" class="btn-download" (click)="download()">
      <mat-icon svgIcon="download-icon"></mat-icon> Download
    </button>
  </div>
</tad-dialog-container>
